import type { PaywallIndexQueryParams } from "@circle-react/helpers/urlHelpers/internalApi/search/paywalls";
import { PAYWALL_STATUS } from "@circle-react/types";

type NullableId = string | number | null;

export const buildUpgradeAvailableParams = ({
  couponId,
  currencyCode,
  mainPaywallId,
  paywallGroupId,
  sourceIntervalType,
}: {
  couponId?: NullableId;
  currencyCode?: string;
  mainPaywallId?: NullableId;
  paywallGroupId?: NullableId;
  sourceIntervalType?: string;
}): PaywallIndexQueryParams => ({
  params: {
    source_interval_type: sourceIntervalType,
    coupon_id: couponId,
    filters: {
      status: PAYWALL_STATUS.ACTIVE,
      currency: currencyCode,
      ...(paywallGroupId
        ? { subscription_group: String(paywallGroupId) }
        : mainPaywallId != null
          ? { paywall_id: String(mainPaywallId) }
          : {}),
    },
  },
});
